import { useEffect } from "react";
import useMdiStore from "store/menus";
import { PAGE_ID_HOME } from "components/constent";
import HomePage from "pages/auth/home";
import { pageList, route } from "../router";
import "./main.scss";

export default function Main() {
  const { tabs, activePageId, addTabs } = useMdiStore();

  useEffect(() => {
    if (activePageId) {
      const menus = route.find((_route) => {
        return _route.id === activePageId?.split("_")[0];
      });

      const tab = menus?.menu.find((_menu: any) => {
        return _menu.id === activePageId;
      });

      const newTab = activePageId === PAGE_ID_HOME ? menus : (tab as any);

      addTabs(newTab);
    }
  }, [activePageId]);

  const pages = pageList.filter((page) => {
    return tabs.some((_page) => _page.id === page.id);
  });

  return (
    <>
      <div className="w-full">
        <main>
          {pages.length === 0 && <HomePage />}
          {pages &&
            pages.map((p: any) => {
              return (
                <div hidden={p.id !== activePageId} key={p.id}>
                  <p.component key={p.id} />
                </div>
              );
            })}
        </main>
      </div>
    </>
  );
}
